(function ($) {

    // globalne referencje do Swiperów – żeby móc je niszczyć przy re-init
    window.dhbDesktopVideoSwiper = window.dhbDesktopVideoSwiper || null;
    window.dhbMobileVideoSwiper  = window.dhbMobileVideoSwiper  || null;

    // GŁÓWNA FUNKCJA INICJALIZUJĄCA – MOŻESZ JĄ WOŁAĆ PO AJAX
    window.wbdmInitVideoSlider = function (root) {
        const $root = root ? $(root) : $(document);

        const isMobile = window.innerWidth < 992;

        const $desktopSwiperContainer = $root.find('.video-slider-swiper');          // desktop .swiper
        const $mobileSwiperContainer  = $root.find('.video-slider-mobile-swiper');   // mobile .swiper

        // jeśli nie ma sliderów – nie rób nic
        if (!$desktopSwiperContainer.length && !$mobileSwiperContainer.length) {
            return;
        }

        // DESTROY stare instancje zanim zrobimy nowe
        if (window.dhbDesktopVideoSwiper) {
            try { window.dhbDesktopVideoSwiper.destroy(true, true); } catch (e) {}
            window.dhbDesktopVideoSwiper = null;
        }
        if (window.dhbMobileVideoSwiper) {
            try { window.dhbMobileVideoSwiper.destroy(true, true); } catch (e) {}
            window.dhbMobileVideoSwiper = null;
        }

        // Count slides
        const desktopSlideCount = $desktopSwiperContainer.find('.swiper-wrapper > .swiper-slide').length || 0;
        const mobileSlideCount  = $mobileSwiperContainer.find('.swiper-wrapper > .swiper-slide').length || 0;

        // slidesPerView
        const desktopSPV = desktopSlideCount <= 1 ? 1 : 1.5;
        const mobileSPV  = 1;

        // If only one slide → switch container width
        if (desktopSlideCount === 1) {
            $desktopSwiperContainer.closest('.container-fluid')
                .removeClass('container-fluid').addClass('container');
        }
        if (mobileSlideCount === 1) {
            $mobileSwiperContainer.closest('.container-fluid')
                .removeClass('container-fluid').addClass('container');
        }

        // ----- helpers -----
        function stopAllVideos($scope) {
            if (!$scope || !$scope.length) return;
            // YouTube -> restore thumbnail
            $scope.find('.youtube-video-wrapper iframe').each(function () {
                const $wrap = $(this).closest('.youtube-video-wrapper');
                const saved = $wrap.data('thumbHtml');
                if (saved) {
                    $wrap.html(saved);
                } else {
                    const url = $wrap.attr('data-yt-url') || '';
                    let id = '';
                    try { id = url.split('/embed/')[1].split('?')[0]; } catch (e) {}
                    if (id) {
                        $wrap.html(
                            '<div class="youtube-thumbnail" style="background-image:url(https://img.youtube.com/vi/' +
                            encodeURIComponent(id) + '/hqdefault.jpg)"><div class="play-button"></div></div>'
                        );
                    } else {
                        $wrap.empty();
                    }
                }
            });
            // HTML5 -> pause & restore
            $scope.find('.internal-video-wrapper video').each(function () {
                try { this.pause(); this.currentTime = 0; } catch (e) {}
                const $wrap = $(this).closest('.internal-video-wrapper');
                const saved = $wrap.data('thumbHtml');
                if (saved) $wrap.html(saved);
            });
        }

        function stopAllAutoplay() {
            try { if (window.dhbDesktopVideoSwiper?.autoplay?.running) window.dhbDesktopVideoSwiper.autoplay.stop(); } catch(e){}
            try { if (window.dhbMobileVideoSwiper?.autoplay?.running)  window.dhbMobileVideoSwiper.autoplay.stop();  } catch(e){}
        }
        function startAllAutoplay() {
            try { if (window.dhbDesktopVideoSwiper?.autoplay && !window.dhbDesktopVideoSwiper.autoplay.running) window.dhbDesktopVideoSwiper.autoplay.start(); } catch(e){}
            try { if (window.dhbMobileVideoSwiper?.autoplay  && !window.dhbMobileVideoSwiper.autoplay.running)  window.dhbMobileVideoSwiper.autoplay.start();  } catch(e){}
        }

        function disableDraggingDuringPlayback() {
            if (window.dhbMobileVideoSwiper)  window.dhbMobileVideoSwiper.allowTouchMove = false;
            if (window.dhbDesktopVideoSwiper) window.dhbDesktopVideoSwiper.allowTouchMove = false;
        }
        function enableDraggingAfterPlayback() {
            if (window.dhbMobileVideoSwiper)  window.dhbMobileVideoSwiper.allowTouchMove = true;
            if (window.dhbDesktopVideoSwiper) window.dhbDesktopVideoSwiper.allowTouchMove = true;
        }

        // ---------- Swiper init (Desktop) ----------
        if (!isMobile && $desktopSwiperContainer.length) {
            const $section = $desktopSwiperContainer.closest('section');

            // pick the visible header buttons
            const desktopNextEl = $section.find('.video-slider-buttons .video-slider-button-next:visible').get(0) || null;
            const desktopPrevEl = $section.find('.video-slider-buttons .video-slider-button-prev:visible').get(0) || null;

            const desktopPaginationEl = $section.find('.video-slider .swiper-pagination:visible').get(0) || null;

            window.dhbDesktopVideoSwiper = new Swiper($desktopSwiperContainer[0], {
                slidesPerView: desktopSPV,
                spaceBetween: 0,
                rewind: true,
                centeredSlides: false,
                autoplay: desktopSlideCount > 1 ? { delay: 3000, disableOnInteraction: true } : false,
                observer: true,
                observeParents: true,
                preventClicks: true,
                preventClicksPropagation: true,
                navigation: (desktopSlideCount > 1 && desktopNextEl && desktopPrevEl)
                    ? { nextEl: desktopNextEl, prevEl: desktopPrevEl }
                    : {}, // disable nav when not usable
                pagination: desktopPaginationEl ? { el: desktopPaginationEl, type: 'progressbar' } : {},
                on: {
                    init() { updateSlideClasses(this); },
                    slideChange() { updateSlideClasses(this); }
                }
            });

            function updateSlideClasses(swiper) {
                $desktopSwiperContainer.find('.swiper-slide').removeClass('manual-active-slide');
                $(swiper.slides[swiper.activeIndex]).addClass('manual-active-slide');
            }

            window.dhbDesktopVideoSwiper.on('slideChange transitionStart', function () {
                stopAllVideos($desktopSwiperContainer);
            });
        }

        // ---------- Swiper init (Mobile) ----------
        if (isMobile && $mobileSwiperContainer.length) {
            const $section = $mobileSwiperContainer.closest('section');
            const mobileNextEl       = $section.find('.video-slider-mobile .video-slider-button-next:visible').get(0)
                || $section.find('.video-slider-mobile-swiper .video-slider-button-next:visible').get(0)
                || null;
            const mobilePrevEl       = $section.find('.video-slider-mobile .video-slider-button-prev:visible').get(0)
                || $section.find('.video-slider-mobile-swiper .video-slider-button-prev:visible').get(0)
                || null;
            const mobilePaginationEl = $section.find('.video-slider-mobile .swiper-pagination:visible').get(0) || null;

            window.dhbMobileVideoSwiper = new Swiper($mobileSwiperContainer[0], {
                slidesPerView: mobileSPV,
                spaceBetween: 16,
                loop: false,
                centeredSlides: false,
                simulateTouch: true,
                grabCursor: true,
                followFinger: true,
                touchStartPreventDefault: false,
                threshold: 3,
                speed: 500,
                observer: true,
                observeParents: true,
                watchOverflow: true,
                preventClicks: true,
                preventClicksPropagation: true,
                navigation: (mobileSlideCount > 1 && mobileNextEl && mobilePrevEl)
                    ? { nextEl: mobileNextEl, prevEl: mobilePrevEl }
                    : {},
                pagination: mobilePaginationEl ? { el: mobilePaginationEl, type: 'progressbar' } : {}
            });

            window.dhbMobileVideoSwiper.on('slideChange transitionStart', function () {
                stopAllVideos($mobileSwiperContainer);
                enableDraggingAfterPlayback();
                startAllAutoplay();
            });
        }

        // ---------- Play handlers (delegowane, więc działają też po AJAX) ----------
        // UWAGA: nie przenosimy tego poza funkcję, ale czyścimy namespace before .on

        $(document)
            .off('click.wbdmVideo', '.youtube-video-wrapper .youtube-thumbnail')
            .on('click.wbdmVideo', '.youtube-video-wrapper .youtube-thumbnail', function (e) {
                e.preventDefault();
                stopAllAutoplay();

                const $wrap  = $(this).closest('.youtube-video-wrapper');
                const ytUrl  = $wrap.attr('data-yt-url');
                const orient = ($wrap.attr('data-yt-orientation') || 'horizontal').toLowerCase();
                if (!ytUrl) return;

                if (!$wrap.data('thumbHtml')) $wrap.data('thumbHtml', $wrap.html());

                const sep = ytUrl.indexOf('?') === -1 ? '?' : '&';
                const src = ytUrl + sep + 'autoplay=1&mute=1&playsinline=1&rel=0';
                const aspect = orient === 'vertical' ? '9/16' : '16/9';

                $wrap.html(
                    '<iframe src="' + src + '" ' +
                    'title="YouTube video" frameborder="0" ' +
                    'allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen ' +
                    'style="width:100%;height:100%;aspect-ratio:' + aspect + ';display:block;"></iframe>'
                );

                disableDraggingDuringPlayback();
            });

        $(document)
            .off('click.wbdmVideo', '.internal-video-wrapper .internal-thumbnail')
            .on('click.wbdmVideo', '.internal-video-wrapper .internal-thumbnail', function (e) {
                e.preventDefault();
                stopAllAutoplay();

                const $wrap  = $(this).closest('.internal-video-wrapper');
                const src    = $wrap.attr('data-video-src');
                if (!src) return;

                if (!$wrap.data('thumbHtml')) $wrap.data('thumbHtml', $wrap.html());

                $wrap.html(
                    '<video class="wbdm-inline-video" controls playsinline preload="metadata" width="100%" autoplay muted style="aspect-ratio:16/9;display:block;">' +
                    '<source src="' + src + '" type="video/mp4">' +
                    'Your browser does not support the video tag.' +
                    '</video>'
                );

                disableDraggingDuringPlayback();

                const v = $wrap.find('video.wbdm-inline-video').get(0);
                if (v) {
                    v.addEventListener('ended', function () {
                        enableDraggingAfterPlayback();
                        startAllAutoplay();
                    });
                }
            });
    };

    // alias, gdyby gdzieś został stary plural
    window.wbdmInitVideoSliders = window.wbdmInitVideoSlider;

    // Pierwsze uruchomienie po załadowaniu strony
    $(function () {
        window.wbdmInitVideoSlider(document);
    });

})(jQuery);
